import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { GrLoaderComponent } from '@components/loaders';
import { GrToastComponent } from '@components/overlays';

import { LoadingService, ThemeService } from '@common/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GrLoaderComponent, GrToastComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, OnDestroy {
  protected readonly loadingService = inject(LoadingService);
  private readonly themeService = inject(ThemeService);

  ngOnInit(): void {
    this.setViewportHeight();
    window.addEventListener('resize', this.setViewportHeight);
  }

  ngOnDestroy() {
    window.removeEventListener('resize', this.setViewportHeight);
  }

  setViewportHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
}
